const matchOptions = ['Matches', 'Does Not Match'];
const binaryOptions = ['Empty', 'Not Empty'];

export const isTextFilterValid = (filter, customValidationLength = null) => {
  if (!filter) {
    return { result: false, error: 'Missing filter' };
  }

  const { operator, searchValues } = filter;
  if (matchOptions.includes(operator)) {
    (searchValues || []).forEach(value => {
      if (value.length === 0) {
        return { result: false, error: 'Please don\'t fill empty values' };
      }
    });
  } else if (binaryOptions.includes(operator)) {
    if (searchValues.length === 0) {
      return { result: true };
    }
    return { result: false, error: 'No Values are allowed in Empty/Not Empty' };
  } else {
    if (searchValues.length > 1) {
      return { result: false, error: 'Please fill just 1 value' };
    }
    if (customValidationLength &&
        searchValues[0] &&
        searchValues[0].length < customValidationLength
    ) {
      return { result: false, error: `Please fill at least ${customValidationLength} characters` };
    }
    if (!customValidationLength && searchValues[0] && searchValues[0].length < 3) {
      return { result: false, error: 'Please fill at least 3 characters' };
    }
  }

  return { result: true };
};

export const isInputFilterEmpty = filter => {
  return (filter && !binaryOptions.includes(filter.operator)) &&
    (filter && filter.searchValues || []).filter(
      value =>
        !(
          value === '' ||
          value === null ||
          value === undefined)).length === 0;
};

export const isValidNotEmptyTextFilter = (filter, customValidationLength = null) => {
  return (!isInputFilterEmpty(filter) && isTextFilterValid(filter, customValidationLength).result);
};

export const isValidNotEmptyValueFilter = filter => {
  return (filter.filter(value => value.checked) || []).length !== 0;
};

export const isValidNotEmptyNumberFilter = filter => {
  return (!isInputFilterEmpty(filter) && isNumberFilterValid(filter).result);
};

export const isNumberFilterValid = filter => {
  const { operator, searchValues } = filter;
  const values = (searchValues || []).filter(value => value !== '');
  if (values.length === 0) {
    return { result: true };
  }

  if (!(values || []).every(value => !isNaN(value))) {
    return { result: false, error: 'Please only use numbers', errorCode: 0 };
  }

  if (operator === 'Between') {
    if (values.length < 2) {
      return { result: false, error: 'Please fill both values', errorCode: 1 };
    }
    if (values[0] === values[1]) {
      return { result: false, error: 'Both values can\'t be equal', errorCode: 2 };
    }
  }

  return { result: true };
};
